export default __webpack_public_path__ + "media/images/front/footer/x_logo-4d73a49285dbe9cac801b0070e254d4c.png";